export default [
    {
        key: 'client.name',
        label: 'Cliente',
        orderBy: 'clients.name'
    },
    {
        key: 'name',
        label: 'Nombre'
    },
    {
        key: 'description',
        label: 'Descripción'
    },
    {
        key: 'venue.name',
        label: 'Sede',
        orderBy: 'venues.name'
    },
    {
        key: 'start_hour',
        label: 'Hora de Inicio'
    },
    {
        key: 'end_hour',
        label: 'Hora de Fin'
    },
    {
        key: 'user.name',
        label: 'Creada por',
        orderBy: 'users.name'
    },
    {
        key: 'days',
        label: 'Días',
        sortable: false
    },
    {
        key: 'controlPoints',
        label: 'Puntos de control',
        sortable: false
    },
    {
        key: 'checkList',
        label: 'Lista de chequeo',
        sortable: false
    },
    {
        key: 'actions',
        label: 'Acciones',
        sortable: false
    },
];